let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f0zmS")).then(() => parcelRequire('3ZJ4A'));